import styled from "styled-components";

export const SpinnerProductWrapper = styled.div`
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
`;

export const ProductContentWrapper = styled.div`
  width: 100%;
  display: inline-flex;
  gap: 24px;
  justify-content: center;
  .product-detail,
  .product-inventory,
  .product-info {
    scroll-margin-top: 180px;
  }
`;

export const ProductContent = styled.div`
  display: flex;
  max-width: 684px;
  flex-direction: column;
  gap: 25px;
  flex: 1 0 0;
`;

export const ProductMapContentContainer = styled.div`
  width: 250px;
`;

export const ProductSaveButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  position: fixed;
  right: 60px;
  top: 92px;
  z-index: 2;
  .delete-container {
    display: flex;
    height: 40px;
    padding: 0px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    color: var(--Grey-B, #24272e);
    &:hover {
      cursor: pointer;
      color: #f93c00;
    }
    > .text {
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      text-decoration-line: underline;
    }
  }
  .duplicate-container {
    display: flex;
    height: 40px;
    padding: 0px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    color: var(--Grey-B, #24272e);
    &:hover {
      cursor: pointer;
      opacity: 0.5;
    }
    > .text {
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      text-decoration-line: underline;
    }
  }
  .button {
    display: inline-block;
  }
`;

export const ProductSaveOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(36, 39, 46, 0.55);
  backdrop-filter: blur(2px);
  pointer-events: all;

  .save-overlay-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 28px 36px;
    min-width: 280px;
    max-width: 90vw;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  }

  .save-overlay-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #24272e;
    text-align: center;
  }

  .save-overlay-hint {
    margin: 0;
    font-size: 13px;
    color: #5c6370;
    text-align: center;
  }

  .save-overlay-bar {
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: #e8eaef;
    overflow: hidden;
  }

  .save-overlay-bar-fill {
    height: 100%;
    border-radius: 4px;
    background: linear-gradient(90deg, #f93c00 0%, #ff6b35 100%);
    transition: width 0.2s ease-out;
  }

  .save-overlay-percent {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: #24272e;
    font-variant-numeric: tabular-nums;
  }
`;
